import Vue from 'vue'
import VueRouter from 'vue-router'
import Storage from '@/plugins/localForage'

import { liveshowLeading, liveshowAllLeading } from './main/liveshow'
import generalLedgerLeading from './main/general-ledger'
import assortLedgerLeading from './main/assort-ledger'
import settingLeading from './main/setting'
import gameLobby from './main/game-lobby'
import operatorGroup from './main/operator-group'
import personalCenterLeading from './main/personal-center'
import other from './main/mainOther'
import websiteManagement from './main/website-management'
import home from './main/home'
import main from '../views/main.vue'
import Login from '../views/login.vue'
import store from '../store'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const $localForage = new Storage();

const constantRoutes = [{
  path: '/',
  name: 'login',
  component: Login,
  meta: { requiresAuth: false }
},
{
  path: '/main/:GD',
  name: 'main',
  meta: { requiresAuth: true, title: '後台管理' },
  component: main,
  redirect: '/main/:GD/home',
  beforeEnter: (to, from, next) => {
    next({ params: { GD: to.params.GD } })
  },
  children: [
    home,
    // acoutLeading, // 帳號管理
    liveshowAllLeading, // 现场监督(各站点)
    liveshowLeading, // 現場監督
    generalLedgerLeading, // 總帳
    assortLedgerLeading, // 分類帳
    settingLeading, // 系统设定
    gameLobby, // 游戏种类
    operatorGroup, //操作員組
    personalCenterLeading, // 个人中心
    ...other, // 其他單頁面
    websiteManagement, // 网站管理
  ]
}
]
const router = new VueRouter({
  mode: 'history',
  routes: constantRoutes
})

router.beforeEach(async (to, from, next) => {
  const value = await $localForage.getItem('member')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store._vm.$root.$data['vue-persist-patch-delay']) {
      store._vm.$root.$on('storageReady', () => {
        next({ path: to.path, query: to.query, params: to.params })
      })
    } else {
      if (value != 'null' && value !== null && value != 'undefined') {
        if (to.params.GD != store.getters.getgameid) {
          next()
        }
        next()
      } else {
        next({ name: 'login' });
      }
    }
  } else {
    next()
  }
})

export default router
